const STORAGE_KEY = 'printideas_guest_favorites';

function readFavorites() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function writeFavorites(ids) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
}

function syncButtonState(button) {
  const id = String(button.dataset.productId || '');
  if (!id) return;
  const active = readFavorites().includes(id);
  button.classList.toggle('is-active', active);
  button.setAttribute('aria-pressed', active ? 'true' : 'false');
  let icon = button.querySelector('.printideas-product-card-favorite__icon');
  if (!icon) {
    icon = document.createElement('span');
    icon.className = 'printideas-product-card-favorite__icon';
    icon.setAttribute('aria-hidden', 'true');
    button.appendChild(icon);
  }
  Array.from(button.childNodes).forEach((node) => {
    if (node !== icon) node.remove();
  });
  icon.textContent = active ? '♥' : '♡';
}

function onFavoriteClick(event) {
  event.preventDefault();
  event.stopPropagation();
  const button = event.currentTarget;
  const id = String(button.dataset.productId || '');
  if (!id) return;
  if (button.dataset.customerLoggedIn !== 'true') {
    showFavoriteLoginModal(button);
    return;
  }
  const favorites = readFavorites();
  const index = favorites.indexOf(id);
  if (index >= 0) favorites.splice(index, 1);
  else favorites.push(id);
  writeFavorites(favorites);
  syncButtonState(button);
}

function showFavoriteLoginModal(button) {
  let modal = document.querySelector('.printideas-favorite-login-modal');
  if (!modal) {
    modal = document.createElement('div');
    modal.className = 'printideas-favorite-login-modal';
    modal.innerHTML = `
      <div class="printideas-favorite-login-modal__backdrop" data-close="true"></div>
      <div class="printideas-favorite-login-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="printideas-favorite-login-title">
        <button type="button" class="printideas-favorite-login-modal__close" aria-label="Close" data-close="true">x</button>
        <h2 id="printideas-favorite-login-title">Save favorites</h2>
        <p>Create an account or sign in to save products for later.</p>
        <div class="printideas-favorite-login-modal__actions">
          <a class="button" data-login-link href="/account/login">Sign in</a>
          <a class="button button--secondary" data-register-link href="/account/register">Create account</a>
        </div>
      </div>
    `;
    document.body.appendChild(modal);
    modal.addEventListener('click', (event) => {
      if (event.target && event.target.dataset && event.target.dataset.close === 'true') {
        modal.classList.remove('is-visible');
      }
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') modal.classList.remove('is-visible');
    });
  }
  const login = modal.querySelector('[data-login-link]');
  const register = modal.querySelector('[data-register-link]');
  if (login && button.dataset.loginUrl) login.href = button.dataset.loginUrl;
  if (register && button.dataset.registerUrl) register.href = button.dataset.registerUrl;
  modal.classList.add('is-visible');
}

function bindFavoriteButtons(root = document) {
  root.querySelectorAll('.printideas-product-card-favorite').forEach((button) => {
    if (button.dataset.printideasFavoriteBound !== 'true') {
      button.dataset.printideasFavoriteBound = 'true';
      button.addEventListener('click', onFavoriteClick);
    }
    syncButtonState(button);
  });
}

function ensureContactAttachLink(root = document) {
  if (!location.pathname.includes('/pages/contact')) return;
  root.querySelectorAll('.printideas-contact-attach-link').forEach((link) => link.remove());
}

function bootPrintIdeasHelpers(root = document) {
  bindFavoriteButtons(root);
  ensureContactAttachLink(root);
}

document.addEventListener('DOMContentLoaded', () => bootPrintIdeasHelpers());
document.addEventListener('shopify:section:load', (event) => bootPrintIdeasHelpers(event.target));
